/* eslint-disable react-refresh/only-export-components */
import { createContext, type ReactNode, useContext } from 'react';

/**
 * True when the job-creation wizard is rendered inside the Appointment
 * Scheduler. Gates the compact "Step 2 Review" prototype styling so it stays
 * confined to the scheduler and the same shared components keep their original
 * look elsewhere (e.g. Advanced Search "Unified Job Create", Job edit dialog).
 */
const SchedulerStyleContext = createContext(false);

export const SchedulerStyleProvider = ({ children }: { children: ReactNode }) => (
  <SchedulerStyleContext.Provider value={true}>{children}</SchedulerStyleContext.Provider>
);

export const useSchedulerStyle = () => useContext(SchedulerStyleContext);
